import { Box, Text } from '@wix/design-system';
import React, { FC, PropsWithChildren } from 'react';

interface LineProps {
  dataHook?: string;
}

export const Line: FC<PropsWithChildren<LineProps>> = ({ children, dataHook }) => {
  const lineFiller = <Box flexGrow={1} backgroundColor="D60" height="1px" />;

  return (
    <div aria-live="polite" role="log" data-hook={dataHook}>
      <Box width="100%" gap="SP2" verticalAlign="middle">
        {lineFiller}
        <Text size="small" secondary>
          {children}
        </Text>
        {lineFiller}
      </Box>
    </div>
  );
};
